module.exports = __webpack_public_path__ + "static/media/KMH_4961.12ebd44c.jpg";